import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CartService extends MainService {

	cart: any = null;
	cartMine: any = null;

	/** array list of the cart items */
	cartItems: any = null;

	guestCartId: any = null;

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router
	) {
		super(http, toastService, storage, router);
	}

	getCart(){
		return new Promise(res => {
			this.storage.get('user').then(user => {
				if(user){
					this.makeRequest('/rest/entrelable/V1/carts/mine', null, 'GET').then(resolve => {
						this.cart = resolve;
						res(resolve);
					});
				}
				else {
					if(this.guestCartId){
						this.get('/rest/entrelable/V1/guest-carts/'+this.guestCartId).subscribe(resolve => {
							this.cart = resolve;
							res(resolve);
						});
					} else {
						res(null);
					}
				}
			});
		});
	}

	getTotals() {
		return new Promise(res => {
			this.storage.get('user').then(user => {
				if(user){
					this.makeRequest('/rest/entrelable/V1/carts/mine/totals', null, 'GET').then(resolve => {
						
						res(resolve);
					});
				}
			});
		});
	}

	/**
	 * apply the discount whenever its possible
	 */
	applyCartDiscount(quote_id, item_id, reloadCart:boolean = true, all:boolean=false, eachMsgToast:boolean = true){
		return new Promise(res => {
			let url = '/rest/entrelable/V1/lns-entrelabel/cart/item/'+quote_id+'/'+item_id+'/discount';
			if(all){
				url += '/msgall';
			}

			this.get(url).subscribe(discount => {
				let d: any = discount;
				if(eachMsgToast){
					d.forEach(msg => {
						this.toastService.add(msg, 'success');
					});
				} else {
					if(typeof d[0] != 'undefined'){
						let discount = d[0].split('% discount');
						let _discount = discount[0].replace('A ','');
						let msg = 'A '+_discount+' discount has been applied to your cart item';
						if(d.length > 1){
							msg += 's';
						}
						this.toastService.add(msg, 'success');
					}
				}
				if(reloadCart) {
					this.getCart();
				}
				this.setLoader(false);
				res(discount);
			});
		});
	}

	/**
	 * get cart item from magento API
	 */
	getCartItems(){
		return new Promise(res => {
			this.storage.get('user').then(user => {

				let _request: any = null;
				if(user){
					let data: any = user;
					let header = {
						"Content-Type": 'application/json',
						"Authorization": 'Bearer ' + data.token
					}
					_request = this.get('/rest/entrelable/V1/carts/mine/items', header);
				}
				else {
					_request = this.get('/rest/entrelable/V1/guest-carts/'+this.guestCartId+'/items');
				}

				if(_request){
					_request.subscribe(result => {
						this.cartMine = result;
						res(result);
					}, error => {
						res(null);
						this.errorHandler(error);
					});
				}
			});
		});
	}

	/**
	 * return from storage or
	 * get from magento API call if not exist
	 */
	getCartId(){
		return new Promise(cartId => {
			this.storage.get('user').then(user => {
				if(user){	
					/** 
					 * to prevent error no such entity with cartId = entity_id 
					 * we will have to fetch the cart id via API every time this method is called
					 * update since 12/30/2021 12:09pm
					 */
					this.getCartIdApi().then(_resolve => {
						let fiveMin = 60 * 5 * 1000;
						this.storage.setLocal('cart_id', _resolve, fiveMin);
						cartId(_resolve);
					});
					
					// this.storage.get('cart_id').then(resolve => {
					// 	if(!resolve){
					// 		this.getCartIdApi().then(_resolve => {
					// 			let fiveMin = 60 * 5 * 1000;
					// 			this.storage.setLocal('cart_id', _resolve, fiveMin);
					// 			cartId(_resolve);
					// 		});
					// 	} else {
					// 		cartId(resolve);
					// 	}
					// });
				}
				else {
					this.storage.get('guest_cart_id').then(questCartId => {
						if(!questCartId){
							this.post('/rest/entrelable/V1/guest-carts', null).subscribe(_resolve => {
								this.guestCartId = _resolve;
								this.storage.setSession('guest_cart_id', _resolve);
								cartId(_resolve);
							});
						} else {
							this.guestCartId = questCartId;
							cartId(questCartId);
						}
					});
				}
			});
		});
	}

	/**
	 * return cart id that came from magento API
	 * this assumes that the user was already loged in 
	 */
	getCartIdApi(){
		return new Promise(res => {
			this.storage.get('user').then(resolve => {
				let data: any = resolve;
				let header = {
					Authorization: 'Bearer ' + data.token
				}
				this.post('/rest/entrelable/V1/carts/mine', '', header)
				.subscribe(result => {
					res(result);
				}, error => {
					res(null);
					this.errorHandler(error);
				});
			});
		});
	}

	/**
	 * this method will call the custom API for adding the
	 * item in the cart. the custom API do the function to 
	 * save the previouse API requests into a single request
	 */
	addToCartV2(formData, firebaseService:any){
		return new Promise(add_to_cart => {
			this.storage.get('user').then(user => {

				let url = this.getUrl(this.getStoreUrl('/V1/hnd-order/cart/add/item'));

				let ajaxData = {
					method: 'POST',
					url: url,
					data: formData,
					error: error => {
						add_to_cart(error);
					},
					success: success => {
						add_to_cart(success);
					},
					complete: complete => {
						
					},
					uploadProgress: (e, uploadProgress) => {
						firebaseService.uploadProgress = uploadProgress;
					}
				}

				let header:any = null;
				if(user){
					ajaxData['headers'] = {
						"Authorization": 'Bearer ' + user['token']
					}
				}

				this.ajax(ajaxData);
			});
		});
	}

	/**
	 * assumed that the item was 
	 * already ordered but simply no artwork
	 * this will upload artwork only for that paticular ordered item
	 */
	uploadArtWorkOnly(formData, firebaseService:any){
		return new Promise((resolve, reject) => {
			this.storage.get('user').then(user => {
				let ajaxData = {
					method: 'POST',
					url: this.getUrl('/rest/entrelable/V1/hnd-order/cart/add/attachment'),
					data: formData,
					error: error => {
						reject(JSON.parse(error));
					},
					success: success => {
						resolve(success);
					},
					complete: complete => {
						
					},
					uploadProgress: (e, uploadProgress) => {
						firebaseService.uploadProgress = uploadProgress;
					}
				}

				let header:any = null;
				if(user){
					ajaxData['headers'] = {
						"Authorization": 'Bearer ' + user['token']
					}
				}

				this.ajax(ajaxData);
			});
		});
	}

	/**
	 * add to cart 
	 */
	addToCart( jsonData, method:any="POST", itemId:any = '' ){
		return new Promise(add_to_cart => {
			this.storage.get('user').then(user => {
				if(user){
					let url = '/rest/entrelable/V1/carts/mine/items';
					if(itemId){
						url += '/'+itemId;
					}
					this.makeRequest(url, jsonData, method).then(cartMine => {
						add_to_cart(cartMine);
					});
				}
				else {
					let url = '/rest/entrelable/V1/guest-carts/'+this.guestCartId+'/items'
					if(itemId){
						url += '/'+itemId;
					}

					let _request: any = null;
					if(method == "POST"){
						_request = this.post(url, jsonData);
					} else {
						_request = this.put(url, jsonData);
					}
					if(_request){
						_request.subscribe(addedToCart => {
							add_to_cart(addedToCart);
						}, error => {
							add_to_cart(null);
							this.errorHandler(error);
						});
					}
				}
			});
		});
	}

	/**
	 * save the attachement information to db of magento platform
	 * this assumes that the user was already loged in 
	 */
	saveAttachment(jsonData){
		return new Promise(attach => {
			this.post('/rest/entrelable/V1/lns-orderattachment/attachment/save', jsonData).subscribe(a => {
				attach(a);
			});
		});
	}

	getItemInfo(cItems){
		this.get('/rest/entrelable/V1/lns-api/quote/cart/item/' + cItems.cart.item_id).subscribe(itemData => {
			if(typeof itemData[0] != 'undefined'){
				let iData: any = itemData[0];
				iData.discount_percent = parseInt(iData.discount_percent);
				iData.price = parseFloat(iData.price);

				if(typeof iData['additional_data'] != 'undefined'){
					try {
						iData['additional_data'] = JSON.parse(iData['additional_data']);
						if(typeof iData['additional_data']['sticker_pad'] != 'undefined'){
							iData['additional_data']['sticker_pad'] = iData['additional_data']['sticker_pad'] + ''; /** make it a string */
						}
					} catch (error) {
						/** do nothing here */
					}
				}

				iData['discounted_price'] = iData.price - (iData.price * (iData.discount_percent / 100));
				// iData['discounted_price'] = parseFloat(iData['discounted_price'].toFixed(2));
				iData['discounted_total'] = iData.base_row_total - iData.discount_amount;
				// iData['discounted_price'] = iData['discounted_total'] / iData.qty;
				cItems.itemData = iData;
			}
		});
	}

	reAddToCart(item:any = {}, additional_custom_options:any = null) {
		return new Promise(res => {
			this.getCartId().then(cartId => {
				let jsonData = {
					"order_id": item.order_id,
					"quote_id": cartId,
					"items": [
						{
							"item_id": item.item_id
						}
					]
				}

				if(additional_custom_options){
					jsonData.items[0]['additional_custom_options'] = additional_custom_options;
				}

				this.makeRequest('/rest/entrelable/V1/lns-api/quote/cart/readditems', jsonData, 'PUT').then(resolve => {
					this.cart = resolve;
					this.setLoader(true);
					res(resolve);
				});
			});
		});
	}

 	/**
 	 * return discount in percent
 	 */
	// getDiscount(qty){
	// 	let discount;
	// 	if(qty >= 500 && qty <= 999){
    //         discount = 4;
    //     }
    //     else if(qty >= 1000 && qty <= 2999){
    //         discount = 5;
    //     }
    //     else if(qty >= 3000 && qty <= 4999){
    //         discount = 8;
    //     }
    //     else if(qty >= 5000){
    //         discount = 10;
    //     }

    //     return discount;
	// }

	/**
	 * get calculated total price of an item
	 * including discount
	 */
	// getPrice(item: any = null, customPrice: any = null){
	// 	item.cart.calculated_discount = '';
	// 	item.cart.calculated_discountAmount = 0;
	// 	item.cart.calculated_discountPercent = 0;
	// 	item.cart.calculated_price = 0;
	// 	item.cart.calculated_subtotal = 0;
	// 	item.cart.calculated_total = 0;

	// 	let size = item.product.option_value;
	// 	if(size){
	// 		size = size.replace(" cm", '');
	// 		size = size.replace(" cm", '');
	// 		size = size.split(" x ");
	// 		let width = parseFloat(size[0]);
	// 		let height = parseFloat(size[1]);

	// 		let sqCm = width * height;

	// 		if(customPrice && sqCm > 0){
	// 			let prodPricing: any = customPrice[item.product.sku];
	// 			prodPricing.forEach(p => {
	// 				if(p.to == "*"){
	// 					if(sqCm >= p.from){
	// 						item.cart.calculated_price = p.price;
	// 					}
	// 				} else {
	// 					if(sqCm >= p.from && sqCm <= p.to){
	// 						item.cart.calculated_price = p.price;
	// 					}
	// 				}
	// 			});

	// 			/* apply 5% additional for Custom Shape */
	// 			if(
	// 	        	item.cart.sku == 'durable-sticker-Custom Shape' || 
	// 	        	item.cart.sku == 'matte-sticker-Custom Shape' || 
	// 	        	item.cart.sku == 'glossy-sticker-Custom Shape'
	// 	        ){
	// 				const fivePercent = item.cart.calculated_price * 0.05;
	// 				item.cart.calculated_price = this.formatNumber(item.cart.calculated_price + fivePercent);
	// 			}
	// 			item.cart.calculated_total = this.formatNumber(item.cart.calculated_price * item.cart.qty);

	// 			/* apply discount whenever it is possible */
				
	// 			let discount = this.getDiscount(item.cart.qty);
	// 	        if (discount > 0) {
	// 	        	discount = this.formatNumber(discount);
	// 				item.cart.calculated_discountPercent = discount;

	// 				let discountForPrice = this.formatNumber( item.cart.calculated_price * (discount / 100) );
	// 				let discountedPrice = this.formatNumber( item.cart.calculated_price - discountForPrice );
	// 				let discountAmount = this.formatNumber(discountForPrice * item.cart.qty);

	// 				item.cart.calculated_discounted_price = discountedPrice;
	// 				item.cart.calculated_discountAmount = this.formatNumber(discountForPrice * item.cart.qty);
	// 				item.cart.calculated_subtotal = this.formatNumber(item.cart.calculated_price * item.cart.qty);
	// 				item.cart.calculated_total =  this.formatNumber(discountedPrice * item.cart.qty);
	// 				item.cart.calculated_discount = discount + '% (PHP '+ (discountAmount) +')';
	// 	        }
	// 		}
	// 	}
	// 	return item;
	// }

	formatNumber(value, decimal:number = 4){
		return parseFloat(window['toFixed'](value, decimal));
		// return parseFloat(value.toFixed(decimal));
	}
}
